<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Grade"
        p-read-link="grid.read.one"
        p-create-link="grid.create"
        p-name="grids"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwGridRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'Descrição',
                value: 'descricao'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>